import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('user-token') || '',
    customer: {},
    orders: {},
    incadeaOrders: [],
    order: {},
    shoppingList: [],
  },
  getters,
  actions,
  mutations,
};
